import { StorefrontItem } from 'DVWebNodeUtils'
import { logError } from './csm';

export default function fireDraperTrackingEvent(item: StorefrontItem, eventName: string) {
  const eventUrl = item &&
    item.prerolls &&
    item.prerolls.trackingEvents &&
    item.prerolls.trackingEvents[eventName]
  if (eventUrl) {
    // not using APIClient here, as the CORS settings of the Draper endpoints
    // prohibit using {credentials: include}
    fetch(eventUrl).catch((er) =>
      logError(er, "Error firing Draper tracking event"))
  }
}
